export const calcDevelopment = (roastingTime: number, timeToFirstCrack: number) => {
  return (roastingTime - timeToFirstCrack) / roastingTime;
};
